import React from 'react';
import DownloadAppPrompt from './DownloadAppPrompt';

const Footer: React.FC = () => {
    return (
        <footer className="bg-white py-12">
            <div className="container mx-auto px-4">
                <div className="flex flex-col sm:flex-row gap-8 sm:gap-16 md:gap-8">
                    <DownloadAppPrompt className="w-full sm:w-1/3 md:w-1/4" />
                    <div className="flex flex-col sm:flex-row gap-8 sm:gap-16 flex-grow justify-between">
                        <div>
                            <h3 className="font-bold text-gray-900 mb-4">Product</h3>
                            <ul className="space-y-2 text-sm">
                                <li><a href="#how-it-works" className="text-gray-600 hover:text-green-600">How it Works</a></li>
                                <li><a href="#benefits" className="text-gray-600 hover:text-green-600">Benefits</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="font-bold text-gray-900 mb-4">Company</h3>
                            <ul className="space-y-2 text-sm">
                                <li><a href="/about" className="text-gray-600 hover:text-green-600">About</a></li>
                                <li><a href="/careers" className="text-gray-600 hover:text-green-600">Careers</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="font-bold text-gray-900 mb-4">Legal</h3>
                            <ul className="space-y-2 text-sm">
                                <li><a href="/privacy" className="text-gray-600 hover:text-green-600">Privacy</a></li>
                                <li><a href="/terms" className="text-gray-600 hover:text-green-600">Terms</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="font-bold text-gray-900 mb-4">Get in touch</h3>
                            <ul className="space-y-2 text-sm">
                                <li>
                                    <a href="/privacy" className="text-gray-600 hover:text-green-600 flex items-center gap-2">
                                        <img src="/icons/phone.svg" alt="Phone" className="w-4 h-4 md:w-4 md:h-4 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform brightness-0 saturate-100 hue-rotate-180" />
                                        +1 (909) 440-6621
                                    </a>
                                </li>
                            </ul>
                            <div className="pt-3">
                                <div className="flex gap-2 md:gap-3 flex-wrap">
                                    <a
                                        href="https://www.linkedin.com/company/mitifreshllc/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-11 h-11 md:w-8 md:h-8 bg-[#0077B5] rounded-full flex items-center justify-center text-white hover:bg-[#006399] transition-all shadow-md hover:shadow-xl hover:scale-110 active:scale-95"
                                        aria-label="Follow us on LinkedIn"
                                    >
                                        <img src="/icons/linkedin.svg" alt="LinkedIn" className="w-5 h-5 md:w-4 md:h-4 brightness-0 invert" />
                                    </a>
                                    <a
                                        href="https://www.instagram.com/miti.fresh?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-11 h-11 md:w-8 md:h-8 bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#FD1D1D] rounded-full flex items-center justify-center text-white hover:opacity-90 transition-all shadow-md hover:shadow-xl hover:scale-110 active:scale-95"
                                        aria-label="Follow us on Instagram"
                                    >
                                        <img src="/icons/instagram.svg" alt="Instagram" className="w-5 h-5 md:w-4 md:h-4 brightness-0 invert" />
                                    </a>
                                    <a
                                        href="https://whatsapp.com/channel/0029VbBE5Rs9WtCChmytKA2j"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-11 h-11 md:w-8 md:h-8 bg-[#25D366] rounded-full flex items-center justify-center text-white hover:bg-[#1ebd59] transition-all shadow-md hover:shadow-xl hover:scale-110 active:scale-95"
                                        aria-label="Join us on WhatsApp"
                                    >
                                        <img src="/icons/whatsapp.svg" alt="WhatsApp" className="w-5 h-5 md:w-4 md:h-4 brightness-0 invert" />
                                    </a>
                                    <a
                                        href="https://nextdoor.com/page/mitisha-llc-sacramento-ca?share_platform=10&utm_campaign=1759954771298&share_action_id=0c0128ae-0f0a-4421-a7b5-f9895505f99d"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-11 h-11 md:w-8 md:h-8 bg-[#00B246] rounded-full flex items-center justify-center text-white hover:bg-[#009938] transition-all shadow-md hover:shadow-xl hover:scale-110 active:scale-95"
                                        aria-label="Find us on Nextdoor"
                                    >
                                        <img src="/icons/nextdoor.svg" alt="Nextdoor" className="w-5 h-5 md:w-4 md:h-4 brightness-0 invert" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-12 pt-8 border-t border-gray-100 text-center text-gray-600 text-sm">
                    &copy; {new Date().getFullYear()} MitiFresh. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;